import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addLead, getLeadSource, getLeadStatus, updateLead } from "../../services/leads";

export default function LeadCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [leadStatusList, setLeadStatusList] = useState([])
  const [leadSourceList, setLeadSourceList] = useState([])
  const [input, setInput] = useState({

    name: state?.name || "",
    mobileNo: state?.mobileNo || "",
    source: state?.source || "",
    amount: state?.amount || "",
    queries: state?.queries || "",
    address: state?.address || "",
  });

  useEffect(() => {

    getLeadStatus()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadStatus = Res.map((item) => ({
            label: item,
            value: item,
          }));
          setLeadStatusList(leadStatus)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    getLeadSource()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const leadSource = Res.map((item) => ({
            label: item,
            value: item,
          }));


          setLeadSourceList(leadSource)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));
  }, [])
  

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    name : "",
    mobileNo : "",
    source : "",
    amount : "",
    queries : "",
    address : "",
  });
 

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.name)) {
      newErrors.name = "Please Enter Name";
      isValid = false;
    } else {
      newErrors.name = "";
    }

    if (!(input.mobileNo)) {
      newErrors.mobileNo = "Please Enter Mobile";
      isValid = false;
    } else {
      newErrors.mobileNo = "";
    }


    if (!(input.source)) {
      newErrors.source = "Please Enter source";
      isValid = false;
    } else {
      newErrors.source = "";
    }

    if (!(input.amount)) {
      newErrors.amount = "Please Enter Amount";
      isValid = false;
    } else {
      newErrors.amount = "";
    }

    if (!(input.queries)) {
      newErrors.queries = "Please Enter Queries";
      isValid = false;
    } else {
      newErrors.queries = "";
    }

    if (!(input.address)) {
      newErrors.address = "Please Enter Address";
      isValid = false;
    } else {
      newErrors.address = "";
    }

    if (input.status === "") {
      newErrors.status = "Please Choose Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {

          lead: {
            id: state?.id,
            followUpOn: null,
            mobileNo: input.mobileNo,
            name: input.name,
            status: input.status,
            source: input.source,
            queries: input.queries,
            address: input.address,
            amount: input.amount
          },
          "leadInfoList": []
        };
        updateLead(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/lead/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          lead: {
            mobileNo: input.mobileNo,
            name: input.name,
            status: input.status,
            source: input.source,
            queries: input.queries,
            address: input.address,
            amount: input.amount
          },
          leadInfoList: []
        };
        addLead(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/lead/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  Lead {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            name: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.name}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Mobile No.
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="mobileNo"
                        name="mobileNo"
                        value={input.mobileNo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobileNo: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobileNo}</div>
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className="col-md-12">
                        <label htmlFor="source" className="form-label">
                          Source
                        </label>
                        <Dropdown
                          style={{ width: "100%" }}
                          options={leadSourceList}
                          value={input.source}
                          onChange={(e) => {
                            setInput({
                              ...input,
                              source: e.value,
                            });
                          }}
                        />
                        <div className="text-danger">{errors.source}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Amount
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="amount"
                        name="amount"
                        value={input.amount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            amount: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.amount}</div>
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Queries
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="queries"
                        name="queries"
                        value={input.queries}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            queries: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.queries}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Address
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="address"
                        name="address"
                        value={input.address}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            address: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.address}</div>
                    </div>

                  </div>

                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={leadStatusList}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
